import { render, staticRenderFns } from "./EditSurveyQuestion.vue?vue&type=template&id=c22b90ee&scoped=true"
import script from "./EditSurveyQuestion.vue?vue&type=script&lang=ts"
export * from "./EditSurveyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./EditSurveyQuestion.vue?vue&type=style&index=0&id=c22b90ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22b90ee",
  null
  
)

export default component.exports